<template>
    <AppLayout
        page="/dashboard"
        pageTitle="Past Due Invoices"
        backLink="/dashboard/reports"
    >
        <v-overlay :value="retryLoading" z-index="999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-col cols="12" class="pa-1">
            <v-card class="soli-round">
                <v-container class="px-3" fluid>
                    <ReportHeader
                        filter
                        :subtitle="`${total} outstanding in ${clients} client(s)`"
                        :dateRange="dateRange"
                        reportUrl="/dashboard/reports/past-due-invoices"
                        dateOptions="month, quarter, year, all"
                        @search="search = $event"
                        ><template #extendedSubtitle>
                            <div>
                                <v-btn
                                    x-small
                                    outlined
                                    class="soli-round soli-blue-text"
                                    @click="
                                        $inertia.reload({
                                            data: {
                                                showUncollectible: Number(
                                                    !showUncollectible
                                                ),
                                            },
                                        })
                                    "
                                    >{{
                                        showUncollectible
                                            ? `Hide Uncollectible`
                                            : `Show Uncollectible`
                                    }}</v-btn
                                >
                            </div>
                        </template>
                        <template #filterItem>
                            <v-list dense>
                                <v-list-item>
                                    <v-btn
                                        :href="`${$page.url}${
                                            hasParams ? '&' : '?'
                                        }csv=true`"
                                        text
                                        outlined
                                        rounded
                                        block
                                        color="dark"
                                        >Download as CSV<v-icon small right
                                            >download</v-icon
                                        ></v-btn
                                    >
                                </v-list-item>
                            </v-list>
                        </template>
                    </ReportHeader>
                    <v-list v-if="false">
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="soli-subtitle"
                                    >{{
                                        `${globalMomentMonthFull()} ${globalMomentYear()}`
                                    }}
                                </v-list-item-title>
                                <v-list-item-subtitle
                                    style="white-space: normal"
                                    >{{ `Customers with past due invoices` }}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle
                                    class="font-bold"
                                    style="white-space: normal"
                                    >{{ total }} outstanding in
                                    {{ clients }} client(s)
                                </v-list-item-subtitle>
                                <v-list-item-subtitle
                                    class="font-bold py-1"
                                    style="white-space: normal"
                                    ><v-btn
                                        x-small
                                        outlined
                                        class="soli-round soli-blue-text"
                                        @click="
                                            $inertia.reload({
                                                data: {
                                                    showUncollectible: Number(
                                                        !showUncollectible
                                                    ),
                                                },
                                            })
                                        "
                                        >{{
                                            showUncollectible
                                                ? `Hide Uncollectible`
                                                : `Show Uncollectible`
                                        }}</v-btn
                                    >
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-row>
                                    <v-menu
                                        right
                                        :close-on-content-click="false"
                                        v-if="$vuetify.breakpoint.xs"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                :small="$vuetify.breakpoint.xs"
                                                icon
                                                class="elevation-3 ml-1"
                                            >
                                                <v-badge
                                                    color="accent"
                                                    overlap
                                                    bordered
                                                    dot
                                                    :value="search"
                                                >
                                                    <v-icon
                                                        class="soli-blue-text text-shadow-blue"
                                                        >filter_list</v-icon
                                                    >
                                                </v-badge></v-btn
                                            >
                                        </template>
                                        <v-list
                                            ><v-list-item class="pl-0">
                                                <v-text-field
                                                    v-model="search"
                                                    class="pl-6 white pt-0 mt-0"
                                                    label="Filter"
                                                    single-line
                                                    clearable
                                                    :append-icon="
                                                        search
                                                            ? null
                                                            : 'filter_list'
                                                    "
                                                    hide-details
                                                ></v-text-field></v-list-item></v-list
                                    ></v-menu>
                                </v-row>
                            </v-list-item-action>
                            <v-list-item-action
                                v-if="$vuetify.breakpoint.smAndUp"
                            >
                                <v-text-field
                                    v-model="search"
                                    style="width: 200px"
                                    class="pl-6"
                                    append-icon="filter_list"
                                    label="Filter"
                                    single-line
                                    hide-details
                                ></v-text-field>
                            </v-list-item-action> </v-list-item
                    ></v-list>
                    <v-data-table
                        :headers="headers"
                        :items="invoices"
                        hide-default-footer
                        disable-pagination
                        mobile-breakpoint="0"
                        :search="search"
                        @click:row="$log($event.id)"
                    >
                        <template v-slot:[`item.user.name`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <v-list-item-avatar
                                    style="float: left"
                                    class="my-0"
                                >
                                    <v-img
                                        :src="item.user.profile_photo_url"
                                    ></v-img>
                                </v-list-item-avatar>
                                <div>
                                    <v-list-item-title>
                                        <Link
                                            :href="`/profile/${item.user.id}/account`"
                                        >
                                            {{ item.user.name }}
                                        </Link>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ item.user.email }}
                                    </v-list-item-subtitle>
                                </div>
                            </div>
                        </template>

                        <template v-slot:[`item.paymentMethod`]="{ item }">
                            <div class="font-bold">
                                <v-icon
                                    v-if="item.paymentMethod"
                                    class="mr-2 soli-blue-text"
                                    >credit_card</v-icon
                                >
                            </div>
                        </template>

                        <template v-slot:[`item.items`]="{ item }">
                            <div v-for="(line, idx) in item.items" :key="idx">
                                {{ line }}
                            </div>
                        </template>

                        <template v-slot:[`item.discounts`]="{ item }">
                            <div
                                v-for="discount in item.discounts"
                                :key="discount"
                            >
                                {{ discount }}
                            </div>
                        </template>

                        <template v-slot:[`item.total`]="{ item }">
                            <div class="font-bold soli-grey">
                                {{ formatUnitAmount(item.total) }}
                            </div>
                        </template>

                        <template
                            v-slot:[`item.last_payment_attempt`]="{ item }"
                        >
                            <div class="font-bold soli-grey">
                                {{ item.last_payment_attempt }}
                            </div>
                        </template>

                        <template v-slot:[`item.invoice_date`]="{ item }">
                            <div class="font-bold soli-grey">
                                {{ item.invoice_date }}
                            </div>
                        </template>

                        <template v-slot:[`item.link`]="{ item }">
                            <div class="flex justify-around transparent">
                                <v-btn-toggle
                                    class="transparent soli-round"
                                    v-model="paymentOptions"
                                >
                                    <v-btn
                                        small
                                        color="white"
                                        @click="viewInvoice(item)"
                                        class="no-link"
                                    >
                                        <v-icon color="soli-green"
                                            >payments</v-icon
                                        >
                                    </v-btn>
                                    <v-btn
                                        small
                                        color="white"
                                        class="no-link"
                                        @click="payInvoice(item)"
                                        :disabled="!item.user.pm_last_four"
                                    >
                                        <v-icon color="secondary"
                                            >restore</v-icon
                                        >
                                    </v-btn>

                                    <v-btn
                                        :disabled="
                                            item.collection_method !==
                                            'send_invoice'
                                        "
                                        small
                                        color="white"
                                        class="no-link"
                                        @click="payByCheck(item)"
                                        ><v-icon color="dark"
                                            >price_check</v-icon
                                        ></v-btn
                                    >
                                    <v-btn
                                        v-if="!showUncollectible"
                                        small
                                        color="white"
                                        class="no-link"
                                        @click="markUncollectible(item)"
                                    >
                                        <v-icon color="error">block</v-icon>
                                    </v-btn>
                                    <v-menu left offset-y>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                small
                                                icon
                                                v-bind="attrs"
                                                v-on="on"
                                                class="no-link"
                                                color="white"
                                                @click="
                                                    paymentOptions =
                                                        !paymentOptions
                                                "
                                                ><v-icon color="dark"
                                                    >more_vert</v-icon
                                                ></v-btn
                                            >
                                        </template>
                                        <v-list dense>
                                            <v-list-item
                                                class="no-link"
                                                @click="viewInvoice(item)"
                                                >View Invoice</v-list-item
                                            >
                                            <v-list-item
                                                class="no-link"
                                                @click="payInvoice(item)"
                                                >Retry</v-list-item
                                            >

                                            <v-list-item
                                                v-if="
                                                    item.collection_method ==
                                                    'send_invoice'
                                                "
                                                class="no-link"
                                                @click="payByCheck(item)"
                                                >Pay By Check</v-list-item
                                            >
                                            <v-list-item
                                                class="no-link"
                                                @click="markUncollectible(item)"
                                                >Mark Uncollectible</v-list-item
                                            >
                                        </v-list></v-menu
                                    >
                                </v-btn-toggle>
                            </div>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>
        </v-col>
        <SoliSnack
            v-if="showMessage"
            @hide="showMessage = false"
            :text="
                $page.props.errors.cardDeclined || $page.props.successMessage
            "
        ></SoliSnack>

        <SoliChoice
            v-if="confirmRetry"
            title="Are you sure?"
            subtitle="This invoice was not initially paid by credit card."
            button1="Charge credit card"
            button2="Nevermind"
            @option1="payInvoice(confirmRetry)"
            @option2="closeConfirmRetry()"
        ></SoliChoice>
        <SoliChoice
            v-if="confirmUncollectible"
            title="Are you sure?"
            subtitle="This invoice will still be available in this report, but hidden by default"
            button1="Mark Uncollectible"
            button2="Nevermind"
            @option1="markUncollectible(confirmUncollectible)"
            @option2="closeModal(() => (confirmUncollectible = false))"
        ></SoliChoice>
        <SoliForm
            v-if="getCheckNumber"
            title="Record check number"
            @reset="closeGetCheckNumber()"
            @submit="payByCheck(getCheckNumber)"
            ><template #body
                ><SoliText
                    label="Check #"
                    number
                    v-model="getCheckNumber.checkNumber"
                    hide-details="auto"
                    :rules="[
                        (val) =>
                            (val || '').length > 0 || 'This field is required',
                    ]"
                ></SoliText></template
        ></SoliForm>
    </AppLayout>
</template>

<script>
import AppLayout from "./../../Layouts/AppLayout";
import { Link } from "@inertiajs/vue2";
import globalMoment from "../../Mixins/GlobalMoment";
import ReportHeader from "../../Components/Reports/ReportHeader.vue";

export default {
    props: {
        invoices: {
            type: Array,
            default: () => [],
        },
        showUncollectible: {
            type: Boolean,
            default: false,
        },
        clients: {
            type: Number,
            default: 0,
        },
        total: {
            type: String,
            default: "0",
        },
        dateRange: {
            type: Array,
            default: () => [],
        },
        hasParams: {
            type: Boolean,
            default: false,
        },
    },
    mixins: [globalMoment],
    components: {
        AppLayout,
        Link,
        ReportHeader,
    },
    data() {
        return {
            search: "",
            showMessage: false,
            retryLoading: false,
            paymentOptions: null,
            confirmRetry: null,
            getCheckNumber: null,
            confirmUncollectible: null,
            headers: [
                {
                    text: "Customer",
                    align: "start",
                    sortable: true,
                    value: "user.name",
                },
                {
                    text: "Card on File",
                    align: "center",
                    sortable: true,
                    value: "paymentMethod",
                },
                {
                    text: "Purchases",
                    align: "start",
                    sortable: true,
                    value: "items",
                },
                {
                    text: "Discounts",
                    align: "start",
                    sortable: true,
                    value: "discounts",
                },
                {
                    text: "Amount Due",
                    align: "start",
                    sortable: true,
                    value: "total",
                },
                {
                    text: "Last Payment Attempt",
                    align: "start",
                    sortable: true,
                    value: "last_payment_attempt",
                },
                {
                    text: "Invoice Date",
                    align: "start",
                    sortable: true,
                    value: "invoice_date",
                },
                {
                    text: "Payment Options",
                    align: "center",
                    sortable: true,
                    value: "link",
                },
            ],
        };
    },
    methods: {
        closeGetCheckNumber() {
            setTimeout(() => {
                this.getCheckNumber = false;
            }, 300);
        },
        closeConfirmRetry() {
            setTimeout(() => {
                this.confirmRetry = null;
            }, 300);
        },
        closeChooseInvoice() {
            setTimeout(() => {
                this.chooseInvoice = null;
            }, 300);
        },
        payByCheck(item) {
            console.log(item);
            if (!item.checkNumber) return (this.getCheckNumber = item);

            this.$inertia.post(
                route("invoice.payByCheck", item.id),
                { checkNumber: item.checkNumber },
                {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {
                        this.showMessage = true;
                        this.retryLoading = false;
                        this.getCheckNumber = null;
                    },
                    onError: (errors) => {
                        console.log(errors);
                        this.showMessage = true;
                        this.retryLoading = false;
                        this.getCheckNumber = null;
                    },
                }
            );
        },
        viewInvoice(item) {
            window.open(item.hosted_invoice_url, "_blank");
        },
        payInvoice(item) {
            if (
                item.collection_method == "send_invoice" &&
                !this.confirmRetry
            ) {
                return (this.confirmRetry = item);
            }

            this.retryLoading = true;
            this.$inertia.post(
                route("invoice.pay", item.id),
                {},
                {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {
                        this.showMessage = true;
                        this.retryLoading = false;
                        this.confirmRetry = null;
                    },
                    onError: (errors) => {
                        console.log(errors);
                        this.retryLoading = false;
                        this.confirmRetry = null;
                    },
                }
            );
        },
        markUncollectible(item) {
            if (!this.confirmUncollectible) {
                return (this.confirmUncollectible = item);
            }

            this.retryLoading = true;
            this.$inertia.post(
                route("invoice.uncollectible", item),
                {},
                {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {
                        this.showMessage = true;
                        this.retryLoading = false;
                        this.confirmUncollectible = null;
                    },
                    onError: (errors) => {
                        console.log(errors);
                        this.retryLoading = false;
                        this.showMessage = true;
                        this.confirmUncollectible = null;
                    },
                }
            );
        },
    },
};
</script>
